import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, FileText, ScrollText, Settings } from 'lucide-react';
import { useAnalytics } from '../../context/AnalyticsContext';
import { useTheme } from '../../context/ThemeContext';

export function Footer() {
    const { resetConsent } = useAnalytics();
    const { isDark } = useTheme();
    return (
        <footer className="bg-card border-t border-border relative z-10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                    <div className="space-y-4">
                        <Link to="/" className="flex items-center">
                            <img src={isDark ? "/logo-dark.svg" : "/logo.svg"} alt="NexusRig" className="h-16 w-auto" />
                        </Link>
                        <p className="text-sm text-muted-foreground">
                            Prémium PC-k és alkatrészek játékosoknak, alkotóknak és szakembereknek.
                            Új és felújított rendszerek.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-heading font-semibold mb-4">Termékek</h4>
                        <ul className="space-y-2 text-sm text-muted-foreground">
                            <li>
                                <Link to="/products/gamer-pc" className="hover:text-primary transition-colors">
                                    Gamer PC-k
                                </Link>
                            </li>
                            <li>
                                <Link to="/products/irodai-pc" className="hover:text-primary transition-colors">
                                    Irodai PC-k
                                </Link>
                            </li>
                            <li>
                                <Link to="/products/munkaallomas" className="hover:text-primary transition-colors">
                                    Munkaállomások
                                </Link>
                            </li>
                            <li>
                                <Link to="/products/alkatreszek" className="hover:text-primary transition-colors">
                                    Alkatrészek
                                </Link>
                            </li>
                            <li>
                                <Link to="/pc-builder" className="hover:text-primary transition-colors">
                                    PC Összeállító
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-heading font-semibold mb-4">Támogatás</h4>
                        <ul className="space-y-2 text-sm text-muted-foreground">
                            <li>
                                <Link to="/products/felujitott" className="hover:text-primary transition-colors">
                                    Felújított termékek
                                </Link>
                            </li>
                            <li>
                                <Link to="/garancia" className="hover:text-primary transition-colors">
                                    Garancia információk
                                </Link>
                            </li>
                            <li>
                                <Link to="/szallitas" className="hover:text-primary transition-colors">
                                    Szállítási feltételek
                                </Link>
                            </li>
                            <li>
                                <Link to="/visszakuldes" className="hover:text-primary transition-colors">
                                    Visszaküldés és visszatérítés
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-heading font-semibold mb-4">Kapcsolat</h4>
                        <ul className="space-y-3 text-sm text-muted-foreground">
                            <li className="flex items-center gap-2">
                                <Mail className="w-4 h-4 text-primary" />
                                <span>info@nexusrig.hu</span>
                            </li>
                            <li className="flex items-center gap-2">
                                <FileText className="w-4 h-4 text-primary" />
                                <Link to="/impresszum" className="hover:text-primary transition-colors">
                                    Impresszum
                                </Link>
                            </li>
                            <li className="flex items-center gap-2">
                                <ScrollText className="w-4 h-4 text-primary" />
                                <Link to="/aszf" className="hover:text-primary transition-colors">
                                    ÁSZF
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-border mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
                    <p className="text-sm text-muted-foreground">
                        &copy; {new Date().getFullYear()} NexusRig. Minden jog fenntartva.
                    </p>
                    <div className="flex items-center gap-4 text-sm text-muted-foreground">
                        <Link to="/adatkezeles" className="hover:text-primary transition-colors">Adatkezelési tájékoztató</Link>
                        <Link to="/cookie" className="hover:text-primary transition-colors">Cookie tájékoztató</Link>
                        <button onClick={resetConsent} className="hover:text-primary transition-colors flex items-center gap-1" data-testid="cookie-settings-btn">
                            <Settings className="w-3 h-3" />Cookie beállítások
                        </button>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
